import styled from 'styled-components'

export const Container = styled.div`
  width: ${props => (props.fullWidth ? '100%' : '22.5rem')};
  margin-left: ${props => (props.fullWidth ? '0' : '5rem')};
  margin-top: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid #dfdfdf;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  gap: 16px;
`

export const LightbulbIcon = styled.img.attrs({
  src: 'images/lightbulb.svg',
})`
  flex-shrink: 0;
`

export const Text = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #8b8b8b;
  font-family: Roboto;
  margin: 0;
  line-height: normal;
  white-space: pre-line;

  a {
    color: #6196e1;
    text-decoration: underline;
  }
`
